module.exports = __webpack_public_path__ + "img/security7.7b3ebd2f.png";